import { Link } from 'react-router-dom'
import { Calendar, Clock } from 'lucide-react'
import posts from '../data/posts.json'

interface BlogPost {
  id: string
  title: string
  slug: string
  excerpt: string
  author: string
  date: string
  readTime: string
  tags: string[]
  published: boolean
}

export function BlogList() {
  const publishedPosts = (posts as BlogPost[]).filter(post => post.published)

  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <div className="mb-12">
        <h1 className="text-4xl font-bold text-legal-900 dark:text-white mb-4">
          Blog de SignWiz
        </h1>
        <p className="text-lg text-legal-600 dark:text-legal-300">
          Guías técnicas y legales sobre firma digital, evidencia digital y derecho informático en Argentina.
        </p>
      </div>

      <div className="space-y-8">
        {publishedPosts.length === 0 ? (
          <p className="text-legal-500 dark:text-legal-400">No hay entradas publicadas aún.</p>
        ) : (
          publishedPosts.map((post) => (
            <article
              key={post.id}
              className="card hover:shadow-lg transition-shadow duration-200"
            >
              <Link to={`/blog/${post.slug}`} className="block">
                <h2 className="text-2xl font-bold text-legal-900 dark:text-white mb-3 hover:text-primary-600 dark:hover:text-primary-400 transition-colors">
                  {post.title}
                </h2>
                <p className="text-legal-700 dark:text-legal-300 mb-4 leading-relaxed">
                  {post.excerpt}
                </p>

                <div className="flex flex-wrap items-center gap-4 text-sm text-legal-500 dark:text-legal-400">
                  <div className="flex items-center gap-1">
                    <Calendar className="w-4 h-4" />
                    <time dateTime={post.date}>
                      {new Date(post.date).toLocaleDateString('es-AR', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                      })}
                    </time>
                  </div>

                  <div className="flex items-center gap-1">
                    <Clock className="w-4 h-4" />
                    <span>{post.readTime}</span>
                  </div>

                  <div className="flex-1" />

                  <div className="flex flex-wrap gap-2">
                    {post.tags.map((tag) => (
                      <span
                        key={tag}
                        className="badge-primary text-xs"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </Link>
            </article>
          ))
        )}
      </div>
    </div>
  )
}
